import { jsx } from "react/jsx-runtime";
import { createContext, useState, useContext } from "react";
const TodoListContext = createContext(void 0);
const TodoListProvider = ({ children, ...rest }) => {
  const [selectedTodo, setSelectedTodo] = useState(null);
  const [showTodoModal, setShowTodoModal] = useState(false);
  const [showTodoMenu, setShowTodoMenu] = useState(false);
  const [patientReferenceId, setPatientReferenceId] = useState(null);
  const [phoneMenuAnchorRef, setPhoneMenuAnchorRef] = useState(null);
  const [taskDetailsAnchorRef, setTaskDetailsAnchorRef] = useState(null);
  const handleTodoToggleControl = (setterCallback) => (value2) => {
    setSelectedTodo(value2);
    setterCallback(!!value2);
  };
  const handleSetPhoneMenu = (value2) => {
    setPatientReferenceId((value2 == null ? void 0 : value2.patientReferenceId) ?? null);
    setPhoneMenuAnchorRef((value2 == null ? void 0 : value2.anchorEl) ?? null);
  };
  const value = {
    selectedTodo,
    showTodoMenu,
    showTodoModal,
    patientReferenceId,
    taskDetailsAnchorEl: taskDetailsAnchorRef,
    phoneMenuAnchorEl: phoneMenuAnchorRef,
    onTodoModal: handleTodoToggleControl(setShowTodoModal),
    onTodo: handleTodoToggleControl(setShowTodoMenu),
    setTaskDetailsAnchorEl: setTaskDetailsAnchorRef,
    setPhoneMenu: handleSetPhoneMenu,
    ...rest
  };
  return /* @__PURE__ */ jsx(TodoListContext.Provider, { value, children });
};
const useTodoListProvider = () => {
  const context = useContext(TodoListContext);
  if (context === void 0) {
    throw new Error("useTodoListProvider must be used within a TodoListProvider");
  }
  return context;
};
export {
  TodoListProvider,
  useTodoListProvider
};
